<template>
  <div>
    <h1 class="header-style">
      Visitor <br>
      Check-Out
    </h1>
    <br>
    <p class="subheader-style">
      Click <font class="next-text">
        'Next'
      </font> to complete the check-out.
    </p>
    <v-stepper
      v-model="userCheckIn"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="userCheckIn > 1"
          step="1"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="userCheckIn > 2"
          step="2"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="userCheckIn > 3"
          color="#000"
          step="3"
        />
      </v-stepper-header>
    </v-stepper>
    <div>
      <visitor-location-verification
        v-if="showLocationVerificationPage"
        :org-settings="orgSettings"
        @verification-completed="toSecondStep"
      />
      <gather-visit-status
        v-if="showVisitStatusePage"
        @visit-status-stored="toThirdStep"
      />
      <review-visitor-check-out
        v-if="showVisitorCheckOutPage"
        @checkout-completed="checkInCompleted"
      />
    </div>
  </div>
</template>

<script>
  import VisitorLocationVerification from '../dialogComponents/VisitorDialogs/checkout/VisitorLocationVerification.vue';
  import GatherVisitStatus from '../dialogComponents/VisitorDialogs/checkout/GatherVisitStatus.vue';
  import ReviewVisitorCheckOut from '../dialogComponents/VisitorDialogs/checkout/ReviewVisitorCheckOut.vue';
  import global from '../../../../mixins/global';
  export default {
    name: 'VisitorCheckOutPage',
    components: {
      'visitor-location-verification': VisitorLocationVerification,
      'gather-visit-status': GatherVisitStatus,
      'review-visitor-check-out': ReviewVisitorCheckOut,
    },
    mixins: [global],
    data () {
      return {
        userCheckIn: 1,
        showLocationVerificationPage: true,
        step1SuccessColor: '',
        showVisitStatusePage: false,
        step2SuccessColor: '',
        showVisitorCheckOutPage: false,
      };
    },
    computed: {
      activeCheckInDetails () {
        return this.$store.getters['swiftuser/getActiveCheckInDetails'];
      },
      isActiveCheckInDetailsFetched () {
        if (Object.keys(this.activeCheckInDetails).length > 0) {
          return true;
        }
        return false;
      },
      checkOutMethodType () {
        return this.$store.getters['swiftuser/getCheckOutMethodType'];
      },
      orgSettings () {
        return this.$store.getters['organization/getOrganizationSettings'];
      },
    },
    async mounted () {
      await this.fetchActiveCheckInDetails();
      this.loadOnMount();
      this.fetchOrgDetails();
    },
    methods: {
      loadOnMount () {
        if (this.checkOutMethodType === null) {
          this.$router.push({ name: 'CheckOut' });
        }
      },
      async fetchOrgDetails () {
        await this.$store.dispatch('organization/fetchOrganizationSettings', this.activeCheckInDetails);
      },
      async fetchActiveCheckInDetails () {
        this.loading = true;
        await this.$store.dispatch('swiftuser/fetchUsersCurrentCheckInDetails').then(response => {
          if (this.isActiveCheckInDetailsFetched === true) {
            this.loading = false;
            return;
          }
          this.loading = false;
          this.$router.push({ name: 'HomePage' });
        }).catch(() => {
          this.loading = false;
          this.$router.push({ name: 'HomePage' });
        });
      },
      toSecondStep () {
        this.step1SuccessColor = '#00796B';
        this.userCheckIn = 2;
        this.showLocationVerificationPage = false;
        this.showVisitorCheckOutPage = false;
        this.showVisitStatusePage = true;
      },
        toThirdStep () {
          this.step2SuccessColor = '#00796B';
          this.userCheckIn = 3;
          this.showLocationVerificationPage = false;
          this.showVisitStatusePage = false;
          this.showVisitorCheckOutPage = true;
        },
        checkInCompleted () {
          this.$router.push({ name: 'HomePage' });
        },
      },
    };
</script>
